import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { listDeal } from '../actions/dealActions'

export default function Deals(props) {
    const dispatch = useDispatch()
    const dealList = useSelector((state) => state.dealList)
    const { loading, error, deals } = dealList

    const [contactId2, setcontactId2] = useState("")
    const contactId = props.contactId;

    useEffect(() => {
        if (contactId != '') {
            if (deals == undefined || contactId != contactId2) {
                dispatch(listDeal(contactId))
                setcontactId2(contactId)
            }
        }
    }, [dispatch, deals, contactId])

    return (
        loading ? (
            <option value="">loading...</option>
        ) : (
            deals ? (
                (deals.length > 0) ? (
                    deals.map(invtyp => (
                        <option value={invtyp.Deal_Id}>{invtyp.Deal_Name}</option>
                    ))
                ) : (
                    <option value="0">No Record Exist!</option>
                )
            ) : (
                <option value="0">{error}</option>
            )
        )
    )
}

